<template>
  <BaseContainer
    class="dnnCloud-order-box"
    :loading="listLoading"
    :isHasPageFt="!listLoading"
  >
    <template v-slot:hd>
      <!--工具条-->
      <el-col :span="18" class="toolbar">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <el-form-item>
            <el-input
              v-model="userName"
              placeholder="用户名"
              style="width: 180px"
              clearable
              @keyup.enter.native="getList(1)"
              @change="getList(1)"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getList(1)"
              >查询</el-button
            >
          </el-form-item>

          <!-- <el-form-item>
            <el-button
              type="primary"
              size="medium"
              v-on:click="imageShow = !imageShow"
              >{{ imageShow ? '展开' : '收起' }}</el-button
            >
          </el-form-item> -->
        </el-form>
      </el-col>
      <el-col :span="3" class="toolbar">
        <div style="float: right">提交任务数：{{ totalCount }}</div>
      </el-col>
      <el-col :span="3" class="toolbar">
        <div style="float: right">生图成功数：{{ successCount }}</div>
      </el-col>
    </template>

    <template v-slot:main>
      <!--列表-->
      <el-table
        :data="dataList"
        highlight-current-row
        :height="maxTbHeight"
        style="width: 100%"
        :header-cell-style="getRowClass"
        @row-dblclick="handleRowClick"
      >
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="80"
        >
          <template slot-scope="scope">
            <span>{{ (pageNumber - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="userName"
          label="用户名"
          min-width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.userId ? scope.row.userName : "-" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="companyname"
          label="企业"
          min-width="240"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.companyname || "-" }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="resolution"
          label="图片大小"
          width="110"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.resolution || "-" }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column
          prop="membershipName"
          label="角色"
          min-width="90"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.membershipName ? scope.row.membershipName : "-"
            }}</span>
          </template>
        </el-table-column> -->

        <el-table-column
          label="通道图"
          width="110"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.modelImgThumbnail || scope.row.modelImg"
              style="height: 37px; width: auto"
              :src="scope.row.modelImgThumbnail || scope.row.modelImg"
              :preview-src-list="[scope.row.modelImg]"
            >
            </el-image>
            <span v-else> - </span>
          </template>
        </el-table-column>

        <el-table-column
          label="原图"
          width="110"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.originalImgThumbnail || scope.row.originalImg"
              style="height: 37px; width: auto"
              :src="scope.row.originalImgThumbnail || scope.row.originalImg"
              :preview-src-list="[scope.row.originalImg]"
            >
            </el-image>
            <span v-else> - </span>
          </template>
        </el-table-column>

        <el-table-column
          label="叠加优化图"
          width="110"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <el-image
              v-if="
                scope.row.optimizationImgThumbnail || scope.row.optimizationImg
              "
              style="height: 37px; width: auto"
              :src="
                scope.row.optimizationImgThumbnail || scope.row.optimizationImg
              "
              :preview-src-list="[scope.row.optimizationImg]"
            >
            </el-image>
            <span v-else> - </span>
          </template>
        </el-table-column>

        <el-table-column
          label="原图优化图"
          width="110"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.satelliteImgThumbnail || scope.row.satelliteImg"
              style="height: 37px; width: auto"
              :src="scope.row.satelliteImgThumbnail || scope.row.satelliteImg"
              :preview-src-list="[scope.row.satelliteImg]"
            >
            </el-image>
            <span v-else> - </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="创建时间"
          width="160"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span> {{ dateTran(scope.row.createTime) }} </span>
          </template>
        </el-table-column>

        <el-table-column label="生成耗时" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span
              v-if="
                scope.row.generationEndTime && scope.row.generationStartTime
              "
            >
              {{
                formatDuration(
                  scope.row.generationEndTime - scope.row.generationStartTime,
                )
              }}
            </span>
            <span v-else> - </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="generationState"
          label="状态"
          width="80"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.generationState === -1">待提交</span>
            <span v-else-if="scope.row.generationState === 0">生成中</span>
            <span v-else-if="scope.row.generationState === 1">完成</span>
            <span v-else-if="scope.row.generationState === 3">错误</span>
            <span v-else-if="scope.row.generationState === 4">取消</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="prompt"
          label="提示词"
          min-width="180"
          show-overflow-tooltip
          v-if="loginType == '0'"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.prompt || "-" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="50" v-if="loginType == '0'">
          <template slot-scope="scope">
            <span class="operate">
              <el-tooltip effect="dark" content="详情" placement="top">
                <span
                  class="dnnfont iconfile-search"
                  @click="handleDetail(scope.row)"
                ></span>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        title="生图详情"
        :visible.sync="dialogVisible"
        width="50%"
        top="5vh"
      >
        <el-row :gutter="20">
          <el-form label-width="100px" class="demo-ruleForm login-container">
            <el-col :span="24">
              <el-form-item label="企业:">
                {{ detail.companyname || "-" }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用户名:">
                {{ detail.userName || "-" }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="角色:">
                {{ detail.membershipName || "-" }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="创建时间:">
                {{ dateTran(detail.createTime) }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图片大小:">
                {{ detail.resolution || "-" }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="提示词:">
                {{ detail.prompt || "-" }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="生图记录id:">
                {{ detail.generationId || "-" }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="通道图:">
                <el-image
                  v-if="detail.modelImgThumbnail || detail.modelImg"
                  style="height: 150px; width: auto"
                  :src="detail.modelImgThumbnail || detail.modelImg"
                  :preview-src-list="[detail.modelImg]"
                >
                </el-image>
                <span v-else> - </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="原图:">
                <el-image
                  v-if="detail.originalImgThumbnail || detail.originalImg"
                  style="height: 150px; width: auto"
                  :src="detail.originalImgThumbnail || detail.originalImg"
                  :preview-src-list="[detail.originalImg]"
                >
                </el-image>
                <span v-else> - </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="叠加优化图:">
                <el-image
                  v-if="
                    detail.optimizationImgThumbnail || detail.optimizationImg
                  "
                  style="height: 150px; width: auto"
                  :src="
                    detail.optimizationImgThumbnail || detail.optimizationImg
                  "
                  :preview-src-list="[detail.optimizationImg]"
                >
                </el-image>
                <span v-else> - </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="原图优化图:">
                <el-image
                  v-if="detail.satelliteImgThumbnail || detail.satelliteImg"
                  style="height: 150px; width: auto"
                  :src="detail.satelliteImgThumbnail || detail.satelliteImg"
                  :preview-src-list="[detail.satelliteImg]"
                >
                </el-image>
                <span v-else> - </span>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </el-dialog>
    </template>

    <template v-slot:ft>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50, 100]"
          :current-page="pageNumber"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </template>
  </BaseContainer>
</template>
<script>
import { mapGetters } from "vuex";
import { API_AIRilab } from "../../../api/index.js";
import BaseContainer from "@/components/BaseContainer";
import fitTableHeight from "@/mixins/fitTableHeight.js";
export default {
  mixins: [fitTableHeight],
  data() {
    return {
      token: "",
      checkCode: "",
      id: "",
      listLoading: false,
      dataList: [],
      souchs: {},
      pageNumber: this.$route.query.pageNumber
        ? this.$route.query.pageNumber
        : 1,
      pageSize: this.$route.query.pageSize ? this.$route.query.pageSize : 20,
      total: 0,
      userName: "",
      dynamicTags: [],
      imageShow: false,
      dialogVisible: false,
      detail: {},
      // 默认按照时间降序排序
      searchText: this.$route.query.searchText,
      successCount: 0,
      totalCount: 0,
      loginType: sessionStorage.getItem("type"),
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  components: {
    BaseContainer,
  },

  methods: {
    handleRowClick(row) {
      this.handleDetail(row);
    },
    getList: function (page) {
      this.pageNumber = page ? page : this.pageNumber;
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        userName: this.userName,
      };
      this.listLoading = true;
      API_AIRilab.getAIRilabStatistics().then((res) => {
        this.successCount = res.data.data.successCount;
        this.totalCount = res.data.data.totalCount;
      });
      API_AIRilab.getAIRilabList(param)
        .then((res) => {
          console.log(res);
          this.dataList = res.data.data.list;
          this.total = res.data.data.totalRow;
          this.listLoading = false;
        })
        .catch((err) => {
          this.$message.error("数据丢失，试试重新登陆！");
          this.listLoading = false;
        });
    },

    dateTran: function (timestamp) {
      if (!timestamp) return "-";
      const date = new Date(timestamp);

      // 获取年、月、日、小时、分钟、秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需要加1
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // 构建所需的格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    formatDuration: function (milliseconds) {
      if (!milliseconds || milliseconds < 0) return "-";

      const totalSeconds = Math.round(milliseconds / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      return `${minutes}分钟${String(seconds).padStart(2, "0")}秒`;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },

    indexMethod(index) {
      return index + 1 + (this.pageNumber - 1) * this.pageSize;
    },
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#F5F7FA";
      } else {
        return "";
      }
    },
    handleDetail(value) {
      this.dialogVisible = true;
      this.detail = value;
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          }
        }
      }
    },
  },

  created() {
    this.getCookie();
    if (this.$route.query.type == 1) {
      this.dynamicTags = JSON.parse(this.$route.query.dynamicTags);
      this.souchs = JSON.parse(this.$route.query.souchs);
      this.pageNumber = JSON.parse(this.$route.query.pageNumber);
    }
    this.getList();
  },
};
</script>

<style lang="scss">
.dnnCloud-order-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
</style>
<style scoped>
.el-select {
  display: inline-block;
  position: relative;
  width: 115px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// AIRilab.vue?dfa85d4a